import './keys.css';
import { Component, h, state, css, page, signal, Fragment } from 'pylevate-runtime';
import { getMe, listKeys, createKey, revokeKey } from '../api.js';
import { Nav } from '../components/nav.js';
export class Keys extends Component {
  constructor(...args) {
    super(...args);
    this._email = signal('');
    this._keys = signal([]);
    this._name = signal('');
    this._fresh = signal('');
    this._error = signal('');
  }
  get email() { return this._email.value; }
  set email(v) { this._email.value = v; }
  get keys() { return this._keys.value; }
  set keys(v) { this._keys.value = v; }
  get name() { return this._name.value; }
  set name(v) { this._name.value = v; }
  get fresh() { return this._fresh.value; }
  set fresh(v) { this._fresh.value = v; }
  get error() { return this._error.value; }
  set error(v) { this._error.value = v; }
  async componentDidMount() {
    let me = await getMe();
    if (!__truthy(me['signed_in'])) {
      window.location.href = '/api/auth/login?next=/keys';
      return;
    }
    this._email.value = me['account']['email'];
    this._keys.value = await listKeys();
  }
  async create() {
    let k;
    try {
      k = await createKey(this._name.value.trim() || 'key', ['chat', 'files', 'exec', 'mcp']);
      this._fresh.value = k['key'];
      this._name.value = '';
      this._keys.value = await listKeys();
    } catch (e) {
      this._error.value = String(e);
    }
  }
  async revoke(kid) {
    try {
      await revokeKey(kid);
      this._keys.value = await listKeys();
    } catch (e) {
      this._error.value = String(e);
    }
  }
  get_context(props) {
    props['keys_'] = this._keys.value;
    props['has_fresh'] = bool(this._fresh.value);
    return props;
  }
  render(props, state, context) {
    const _ctx = this.get_context(props || {});
    const { keys_, has_fresh } = _ctx;
    const children = props && props.children;
    return h('div', null, h(Fragment, null, h(Nav, {email: this._email.value}), h('div', {className: 'wrap-f005a1'}, h(Fragment, null, h('div', {className: 'card-f005a1'}, h(Fragment, null, h('h3', null, 'Create a key'), h('p', {className: 'muted-f005a1'}, 'Use it as a Bearer token against /api/v1/… and as the MCP server credential. It is shown once.'), h('div', {className: 'row-f005a1'}, h(Fragment, null, h('input', {placeholder: 'Name (e.g. laptop, CI)', value: this._name.value, onInput: e => this._name.value = e.target.value}), h('button', {className: 'btn-f005a1 primary-f005a1', onClick: this.create.bind(this)}, 'Create'))), (has_fresh ? h('div', {className: 'fresh-f005a1'}, `${this._fresh.value}`) : null), (this._error.value ? h('p', {className: 'err-f005a1'}, `${this._error.value}`) : null))), h('div', {className: 'card-f005a1'}, h(Fragment, null, h('h3', null, 'Your keys'), h('table', null, h(Fragment, null, h('thead', null, h('tr', null, h(Fragment, null, h('th', null, 'Name'), h('th', null, 'Prefix'), h('th', null, 'Scopes'), h('th', null, 'Last used'), h('th', null)))), h('tbody', null, keys_.map((k) => h('tr', {key: k.id}, h(Fragment, null, h('td', null, `${k.name}`), h('td', null, `${k.prefix}…`), h('td', null, `${k.scopes.join(", ")}`), h('td', null, `${k.last_used_at || "never"}`), h('td', null, h(Fragment, null, (!__truthy(k.revoked) ? h('button', {className: 'btn-f005a1 danger-f005a1', onClick: () => this.revoke(k.id)}, 'Revoke') : null), (k.revoked ? h('span', {className: 'muted-f005a1'}, 'revoked') : null)))))))))))))));
  }
}
Keys = page({title: 'API keys — eutonomous', route: '/keys'})(Keys);
